module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc6-2323d13d53bc0c439f6ae90b148dd94e.jpg";